module.exports = __webpack_public_path__ + "img/news_1.0453362d.png";